import { asContainer } from 'lib/container'

export const container = asContainer<{}>()({
	path: '/',
	Running: () => <div>Start component</div>,
})
